<!-- Hero Section -->
<section class="hero-section">
  <div class="hero-background">
    <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="hero-img">
    <div class="hero-overlay"></div>
  </div>

  <div class="hero-content">
    <span class="hero-tagline">A Heritage of Love</span>
    <h1 class="hero-title">Find Your Perfect<br>Life Partner</h1>
    <p class="hero-text">
      Experience a matrimonial journey built on tradition, family values, and curated connections. Where heritage meets
      modern search capabilities.
    </p>
    <div class="hero-actions">
      <a [routerLink]="isLoggedIn ? '/dashboard' : '/signup-basic'" class="gold-button hero-cta">
        <span>Create Free Profile</span>
        <span class="material-symbols-outlined">arrow_forward</span>
      </a>
      <a routerLink="/plans" class="maroon-outline-button hero-secondary-cta">
        View Premium Plans
      </a>
    </div>

    <!-- Broker & Admin Portal Access -->
    <!-- <div class="portal-access-banner" *ngIf="!isLoggedIn">
      <span class="portal-text">Are you a Marriage Broker or Administrator?</span>
      <div class="portal-buttons">
        <a routerLink="/broker/login" class="portal-btn broker-btn" title="Broker Portal (Login / Register Agency)">
          <span class="material-symbols-outlined">handshake</span> Broker Portal (Login / Register)
        </a>
        <a routerLink="/admin/login" class="portal-btn admin-btn" title="Admin Panel Login">
          <span class="material-symbols-outlined">admin_panel_settings</span> Admin Login
        </a>
      </div>
    </div> -->
  </div>
</section>

<!-- Quick Search Console -->
<section class="search-section">
  <div class="search-panel">
    <form (submit)="onSearch($event)" class="search-form">
      <div class="search-field">
        <label for="lookingFor">Looking For</label>
        <select id="lookingFor" name="lookingFor" [(ngModel)]="lookingFor">
          <option value="Men">Groom (Men)</option>
          <option value="Women">Bride (Women)</option>
        </select>
      </div>

      <div class="search-field range-field">
        <label>Age Range</label>
        <div class="range-inputs">
          <input type="number" name="ageFrom" [(ngModel)]="ageFrom" placeholder="21" min="18" max="70">
          <span>to</span>
          <input type="number" name="ageTo" [(ngModel)]="ageTo" placeholder="35" min="18" max="70">
        </div>
      </div>

      <div class="search-field">
        <label for="religion">Religion</label>
        <select id="religion" name="religion" [(ngModel)]="religion">
          <option value="Any Religion">Any Religion</option>
          <option value="Hindu">Hindu</option>
          <option value="Muslim">Muslim</option>
          <option value="Christian">Christian</option>
          <option value="Sikh">Sikh</option>
          <option value="Jain">Jain</option>
        </select>
      </div>

      <div class="search-field">
        <label for="location">Location</label>
        <input type="text" id="location" name="location" [(ngModel)]="location" placeholder="City or Country">
      </div>

      <button type="submit" class="gold-button search-submit-btn" aria-label="Search Profiles">
        <span class="material-symbols-outlined">search</span>
      </button>
    </form>
  </div>
</section>

<!-- Guest Search Results Section -->
<section class="results-section" *ngIf="searched">
  <!-- Loading state -->
  <div class="results-loader py-3 text-center" *ngIf="loadingMatches">
    <div class="spinner-border text-maroon" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Results list grid -->
  <div class="container py-2" *ngIf="!loadingMatches && filteredMatches.length > 0">
    <div class="guest-results-heading">
      <div class="heading-row">
        <h2 class="results-title">
          Matching Profiles
          <span class="match-count-badge">{{ filteredMatches.length }} premium matches</span>
        </h2>
        <span class="found-matches-badge">Premium Matches</span>
      </div>
    </div>

    <div class="results-grid">
      <div class="match-card-wrapper"
        *ngFor="let profile of (isLoggedIn ? filteredMatches : filteredMatches.slice(0, 3))">
        <div class="premium-card match-card h-100">
          <div class="card-image-wrapper position-relative">
            <ng-container *ngIf="base64Images[profile._id]; else defaultAvatar">
              <img [src]="'data:image/jpeg;base64,' + base64Images[profile._id]" alt="Profile picture"
                class="card-img blurred-photo">
            </ng-container>
            <ng-template #defaultAvatar>
              <div class="default-avatar-placeholder blurred-photo">
                <span class="material-symbols-outlined">person</span>
              </div>
            </ng-template>
            <div class="card-img-overlay"></div>
            <div class="lock-overlay">
              <span class="material-symbols-outlined">lock</span>
              <span class="lock-text">Preview Mode</span>
            </div>

            <!-- Shortlist Button -->
            <button (click)="$event.stopPropagation(); redirectToSignup()" class="shortlist-btn"
              aria-label="Shortlist profile">
              <span class="material-symbols-outlined">star_border</span>
            </button>
          </div>

          <div class="card-body-content">
            <div class="card-profile-details">
              <h3 class="profile-name">{{ getMaskedName(profile) }}</h3>
              <p class="profile-meta">
                <span>{{ getAge(profile.basic_info?.date_of_birth) }} yrs</span> &bull;
                <span>{{ profile.personal_info?.marital_status || 'Never Married' }}</span>
              </p>
              <div class="profile-badges d-flex flex-wrap gap-1">
                <span class="badge-custom" *ngIf="getCasteName(profile)">{{ getCasteName(profile) }}</span>
                <span class="badge-custom" *ngIf="getOccupationName(profile)">{{ getOccupationName(profile) }}</span>
              </div>
            </div>

            <div class="card-actions-row">
              <button (click)="$event.stopPropagation(); redirectToSignup()"
                class="gold-button btn-sm w-100 justify-content-center">
                <span class="material-symbols-outlined">favorite</span>
                <span>Send Interest</span>
              </button>
            </div>
          </div>

          <a [routerLink]="['/profile-details', profile._id]" class="card-full-link"></a>
        </div>
      </div>
    </div>

    <!-- More matches signup prompt -->
    <div class="more-matches-prompt" *ngIf="!isLoggedIn && filteredMatches.length > 3">
      <div class="prompt-content">
        <span class="material-symbols-outlined prompt-lock-icon">lock_open</span>
        <h3 class="font-playfair">Unlock {{ filteredMatches.length - 3 }} More Matches</h3>
        <p class="prompt-description">Create a free profile or sign in to view all matching profiles, send interests,
          and chat with your matches.</p>
        <div class="prompt-actions">
          <a routerLink="/signup-basic" class="gold-button prompt-btn">
            <span>Create Free Profile</span>
            <span class="material-symbols-outlined">arrow_forward</span>
          </a>
          <a routerLink="/login" class="maroon-outline-button prompt-btn">
            <span>Sign In</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div class="no-data-card py-5 px-4 text-center mt-4" *ngIf="!loadingMatches && filteredMatches.length === 0">
    <span class="material-symbols-outlined text-muted font-size-xxl mb-3">group_off</span>
    <h4>No Matches Found</h4>
    <p class="text-muted">No matching profiles found. Try adjusting your search criteria.</p>
  </div>
</section>

<!-- Foundation of Trust Section -->
<section class="trust-section">
  <div class="section-container">
    <div class="section-header">
      <h2>Foundation of Trust</h2>
      <p>We prioritize safety and authenticity to ensure your journey to finding a partner is secure and meaningful.</p>
    </div>
    <div class="trust-grid">
      <div class="trust-card">
        <div class="trust-icon-container verified">
          <span class="material-symbols-outlined">verified_user</span>
        </div>
        <h3>Verified Profiles</h3>
        <p>Every profile undergoes a manual verification process to ensure genuine intentions and real people.</p>
      </div>

      <div class="trust-card">
        <div class="trust-icon-container privacy">
          <span class="material-symbols-outlined">lock</span>
        </div>
        <h3>Privacy Controls</h3>
        <p>You control your data. Manage who sees your photos, contact details, and horoscope with granular privacy
          settings.</p>
      </div>

      <div class="trust-card">
        <div class="trust-icon-container family">
          <span class="material-symbols-outlined">family_restroom</span>
        </div>
        <h3>Family-First Approach</h3>
        <p>Designed with tradition in mind, supporting parent-managed profiles and family involvement in matchmaking.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- Success Stories Section -->
<section class="stories-section">
  <div class="section-container">
    <div class="section-header">
      <h2>Success Stories</h2>
      <p>Witness the beautiful unions that started right here.</p>
    </div>
    <div class="stories-grid">
      <!-- Story 1 -->
      <div class="story-card">
        <div class="story-image-wrap">
          <img
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuDrh4CigBI8Dg04WPYy4zOf_v7nOz_6dNl53-2qA-Rzwhul1TlXuPDITuLSpv-dp_o2cAXdTBYJ4hBgdQlODREjNy2TsgQdK8PtcUrt5A5vRU_Bg2MIdTmWcUrmwcjKPNWbCZxGRA49ljS1qmxAxXjWOpJnmjP-uS8Z0yoxvPjkseZu6bjj0DhGpIQybM_siupEroXefHLwJVkn0EMzYXCF0PEEwRu9ZemQUxbre8Yoo0CTjZ827_JRMQ1pWFXvKsikm_63JF9fA2Q"
            alt="Arjun and Priya">
        </div>
        <div class="story-details">
          <span class="quote-mark">“</span>
          <p class="story-quote">We found each other through matching suggestions. It felt like our families had known
            each other for years from the very first meeting.</p>
          <h4 class="story-names">Arjun & Priya</h4>
          <span class="story-date">Married June 2024</span>
        </div>
      </div>

      <!-- Story 2 -->
      <div class="story-card">
        <div class="story-image-wrap">
          <img
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuCfoHh3xH0BdY2_Wj-eYzD9Sn48t3JB4qlNOTxrc5ZNqhkN2J2NoCDIgyr7zNyJsDgzBRCCSfmm98THH63hUL2sRUMkE1kPVqoXXnOLf5nGhIpM7As89UruCOJqHYubA9cdyG6lt56Y-czDHjvl-4pMI5fFAdq0_LNt1bDw9s7K9FKihaQnWuHyil2nMevGpkvGMAm84s3y2XUxf1Ad2F-sogrV5TqrvHD76Ucj9cU3OMGYL6_shr1LVKb7Q0q2t6TPHl_Q6rRUwsA"
            alt="Zayn and Layla">
        </div>
        <div class="story-details">
          <span class="quote-mark">“</span>
          <p class="story-quote">The verification process gave me the confidence to open up. It made it easy to filter
            for shared values and professional backgrounds.</p>
          <h4 class="story-names">Zayn & Layla</h4>
          <span class="story-date">Married Oct 2024</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Call To Action -->
<section class="cta-section">
  <div class="cta-content">
    <h2>Begin Your Story Today</h2>
    <p>Thousands of verified profiles are waiting to find a partner. Join our trusted community now.</p>
    <a [routerLink]="isLoggedIn ? '/dashboard' : '/signup-basic'" class="gold-button cta-btn">
      Create My Profile
    </a>

    <!-- Broker & Admin Portal Access in CTA -->
    <div class="cta-portal-access" *ngIf="!isLoggedIn">
      <div class="portal-divider"><span>OR</span></div>
      <p class="portal-subtext">Are you a Marriage Broker agency or Platform Administrator?</p>
      <div class="cta-portal-buttons">
        <a routerLink="/broker/login" class="portal-btn-alt broker-btn-alt">
          <span class="material-symbols-outlined">handshake</span> Broker Portal (Login / Register)
        </a>
        <a routerLink="/admin/login" class="portal-btn-alt admin-btn-alt">
          <span class="material-symbols-outlined">admin_panel_settings</span> Admin Login
        </a>
      </div>
    </div>
  </div>
</section>